import script from "./RouteRecoderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteRecoderPage.vue?vue&type=script&setup=true&lang=js"

import "./RouteRecoderPage.vue?vue&type=style&index=0&id=1d172c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d172c16"]])

export default __exports__